import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Niveau } from 'app/models/niveau.model';


@Injectable({
  providedIn: 'root'
})
export class NiveauService {

  private API_URL = environment.API_URL;
  private MODEL_URL = 'niveaux';

  constructor(private http: HttpClient) { }

  getNiveaux(): Observable<Niveau[]> {
    return this.http.get<Niveau[]>(this.API_URL + this.MODEL_URL);
  }

  getNiveauxAvecCroquis(idFicheIntervention: number): Observable<Niveau[]> {
    return this.http.get<Niveau[]>(this.API_URL + this.MODEL_URL + '/fiches-interventions/' + idFicheIntervention);
  }

  store(niveau: Niveau): Observable<Niveau>{
    return this.http.post<Niveau>(this.API_URL + this.MODEL_URL, niveau).pipe(
      catchError(err => throwError(err))
    );
  }
}
